// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"officeCitizenry_wrapper__txvdi","button":"officeCitizenry_button__FG6ZB"};